/* eslint-disable */
import $ from 'jquery';
import EventBus from "assets/js/eventBus";
import axios from "assets/js/request";
import imgDefault from "assets/img/noimage.gif";
import openNewWindowBtn from 'assets/img/open-new-window16x16.png';
import UrlConstants from "assets/const/UrlConstants";
var common = {
    initFlag: true,
    initFlagCC: true,
    helpFlg: 0,
    /* 
     * Function errorAPI 
     * analyst error data and display error Modal
     */
    errorAPI(err) {
        let httpStatus = {};
        if (err.response === undefined) {
            console.log('err',err);
            EventBus.$emit("error-httpStatus", httpStatus);
            return;
        } else {
            httpStatus.status = err.response.status;
            if (err.response.data != undefined) {
                httpStatus.errorCode = err.response.data.errorCode;
                httpStatus.message = err.response.data.message;
                httpStatus.path = err.response.data.path;
            }
        }

        let status = err.response.status;
        switch (status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 500:
                EventBus.$emit("error-httpStatus", httpStatus);
                break;
            case 406:
                EventBus.$emit("error-list", err);
                break;
        }
    },
    /* 
     * Function excuteValidation 
     * analyst data message and display
     * @special: in CC screen(popup), fix for ID of CC dulicate with other screen
     * @ptIdScreen: screen code of PT(ecsite)
     */
    excuteValidation(error, special) {
        var mapMsg = [];
        var msgList = [];
        var listIdErr = [];
        // check error list
        if (error.response.data.errorList != null && error.response.data.errorList.length > 0) {
            var errorList = error.response.data.errorList;
            for (var index = 0; index < errorList.length; index++) {
                // row of table
                var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                // zoneIndex
                var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;
                var listIdGroupTemp = [];
                // set border-color for input
                var listGroupId = errorList[index].groupId;
                if (listGroupId != null && listGroupId.length > 0) {
                    for (var keyInx = 0; keyInx < listGroupId.length; keyInx++) {
                        var idInput = '';
                        if (zoneIndex > -1) {
                            idInput = listGroupId[keyInx] + "_" + zoneIndex;
                            if (rowTableIndex > -1) {
                                idInput += "_" + rowTableIndex;
                            }
                        } else {
                            if (rowTableIndex > -1) {
                                idInput = listGroupId[keyInx] + "_" + rowTableIndex;
                            } else {
                                idInput = listGroupId[keyInx];
                            }
                        }
                        var inputObj;
                        if (special != null && special != undefined && special != '') {
                            inputObj = $('#' + idInput + special);
                        } else {
                            inputObj = $('#' + idInput);
                        }

                        if (inputObj != null && inputObj != undefined) {
                            inputObj.css('border-color', "red");
                        }
                        listIdGroupTemp.push(idInput);
                        listIdErr.push(idInput);
                    }
                }

                // replace messenge
                var messageList = errorList[index].messageList;
                if (messageList != null && messageList.length > 0) {
                    for (var mesInx = 0; mesInx < messageList.length; mesInx++) {
                        var msgTemp = messageList[mesInx].message;
                        var argList = messageList[mesInx].argList;
                        if (argList != null && argList.length > 0) {

                            for (var arg = 0; arg < argList.length; arg++) {
                                // get lable display of item input 
                                var idInput = $('#' + argList[arg] + '_lbl');
                                var label = '';

                                if (idInput != null && idInput != undefined) {
                                    label = idInput.text();
                                }
                                // replace text for key to display
                                if (rowTableIndex > -1) {
                                    if (label.length > 0) {
                                        msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);
                                    } else {
                                        msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);
                                    }
                                } else {
                                    if (label.length > 0) {
                                        msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);
                                    }
                                }
                            }
                        }
                        // if message not include key(message common)
                        if (listIdGroupTemp != null && listIdGroupTemp.length > 0) {
                            var obj = {};
                            obj.key = listIdGroupTemp[0];
                            obj.mess = msgTemp;
                            mapMsg.push(obj);
                        } else {
                            msgList.push(msgTemp);
                        }

                    }
                }
            }
            if (listIdErr != null && listIdErr.length > 0) {
                var item = null;
                if (special != null && special != undefined && special != '') {
                    item = $('#' + listIdErr[0] + special);
                } else {
                    item = $('#' + listIdErr[0]);
                }
                if (item != null && item != undefined) {
                    item.focus();
                }
            }

            // emit message to componet message
            var msg = {};
            msg.listMess = msgList;
            msg.mapMsg = mapMsg;
            if (special != null && special != undefined && special != '') {
                EventBus.$emit('messageCC', msg);
            } else {
                EventBus.$emit('message', msg);
            }

            return listIdErr;
        }
    },
    /* 
     * Function clearMessage 
     * clear message when click update, insert
     * @special: in CC screen(popup), fix for ID of CC dulicate with other screen
     * @idPTscreen: idPtScreen
     */
    clearMessage(listIdErr, specialCc) {
        if (listIdErr != null && listIdErr != undefined) {
            // set border-color default for id list error
            var inputObj = null;
            for (var idInx = 0; idInx < listIdErr.length; idInx++) {

                if (specialCc != null && specialCc != undefined && specialCc != '') {
                    inputObj = $('#' + listIdErr[idInx] + specialCc);
                } else {
                    inputObj = $('#' + listIdErr[idInx]);
                }
                if (inputObj != null && inputObj != undefined) {
                    inputObj.css('border-color', "#ced4da");
                }
            }
        }

        // emit blank message to componet message
        var msg = {};
        msg.listMess = [];
        msg.mapMsg = [];
        if (specialCc != null && specialCc != undefined && specialCc != '') {
            EventBus.$emit('messageCC', msg);
        } else {
            EventBus.$emit('message', msg);
        }
    },
    /* 
     * Function excuteValidationEcSite 
     * analyst data message and display
     * @ptIdScreen: screen code of PT(ecsite)
     */
    excuteValidationEcSite(error, ptIdScreen) {
        var result = {};
        var mapMsg = [];
        var msgList = [];
        var listIdErr = [];
        // check error list
        if (error.response.data.errorList != null && error.response.data.errorList.length > 0) {
            var errorList = error.response.data.errorList;
            for (var index = 0; index < errorList.length; index++) {
                // row of table
                var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                // zoneIndex
                var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;
                var listIdGroupTemp = [];
                // set border-color for input
                var listGroupId = errorList[index].groupId;
                if (listGroupId != null && listGroupId.length > 0) {
                    for (var keyInx = 0; keyInx < listGroupId.length; keyInx++) {
                        var idInput = '';
                        if (zoneIndex > -1) {
                            idInput = listGroupId[keyInx] + "_" + zoneIndex;
                            if (rowTableIndex > -1) {
                                idInput += "_" + rowTableIndex;
                            }
                        } else {
                            if (rowTableIndex > -1) {
                                idInput = listGroupId[keyInx] + "_" + rowTableIndex;
                            } else {
                                idInput = listGroupId[keyInx];
                            }
                        }
                        var inputObj;
                        if (ptIdScreen != null && ptIdScreen != undefined && ptIdScreen != '') {
                            inputObj = $('.' + ptIdScreen + ' #' + idInput);
                        } else {
                            inputObj = $('#' + idInput);
                        }

                        if (inputObj != null && inputObj != undefined) {
                            inputObj.css('border-color', "red");
                        }
                        listIdGroupTemp.push(idInput);
                        listIdErr.push(idInput);
                    }
                }

                // replace messenge
                var messageList = errorList[index].messageList;
                if (messageList != null && messageList.length > 0) {
                    for (var mesInx = 0; mesInx < messageList.length; mesInx++) {
                        var msgTemp = messageList[mesInx].message;
                        var argList = messageList[mesInx].argList;
                        if (argList != null && argList.length > 0) {

                            for (var arg = 0; arg < argList.length; arg++) {
                                // get lable display of item input 
                                var idInput;
                                if (ptIdScreen != null && ptIdScreen != undefined && ptIdScreen != '') {
                                    idInput = $('.' + ptIdScreen + ' #' + argList[arg] + '_lbl');
                                } else {
                                    idInput = $('#' + argList[arg] + '_lbl');
                                }
                                var label = '';

                                if (idInput != null && idInput != undefined) {
                                    label = idInput.text();
                                }
                                // replace text for key to display
                                if (rowTableIndex > -1) {
                                    if (label.length > 0) {
                                        msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);
                                    } else {
                                        msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);
                                    }
                                } else {
                                    if (label.length > 0) {
                                        msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);
                                    }
                                }
                            }
                        }
                        // if message not include key(message common)
                        if (listIdGroupTemp != null && listIdGroupTemp.length > 0) {
                            var obj = {};
                            obj.key = listIdGroupTemp[0];
                            obj.mess = msgTemp;
                            mapMsg.push(obj);
                        } else {
                            msgList.push(msgTemp);
                        }

                    }
                }
            }
            if (listIdErr != null && listIdErr.length > 0) {
                var item = null;
                if (ptIdScreen != null && ptIdScreen != undefined && ptIdScreen != '') {
                    item = $('.' + ptIdScreen + ' #' + listIdErr[0]);
                } else {
                    item = $('#' + listIdErr[0]);

                }
                if (item != null && item != undefined) {
                    item.focus();
                }
            }

            // return result
            result.msgList = msgList;
            result.mapMsg = mapMsg;
            result.listIdErr = listIdErr;

            return result;
        }
    },
    /* 
     * Function clearMessageEcSite 
     * clear message when click update, insert
     * @ptIdScreen: screen code of PT(ecsite)
     */
    clearMessageEcSite(listIdErr, idPTscreen) {
        if (listIdErr != null && listIdErr != undefined) {
            // set border-color default for id list error
            var inputObj = null;
            for (var idInx = 0; idInx < listIdErr.length; idInx++) {

                if (idPTscreen != null && idPTscreen != undefined && idPTscreen != '') {
                    inputObj = $('.' + idPTscreen + ' #' + listIdErr[idInx]);
                } else {
                    inputObj = $('#' + listIdErr[idInx]);
                }
                if (inputObj != null && inputObj != undefined) {
                    inputObj.css('border-color', "#ced4da");
                }
            }
        }
    },
    /* 
     * Function nvl for string item 
     */
    stringNvl: function (item, def) {
        if(def == null || def == undefined){
            def = '';
        }
        if (item == null || item == undefined) {
            return def;
        }
        return item;
    },
    /*
     * Function nvl for number item 
     */
    numberNvl: function (item, def) {
        if (def == null || def == undefined) {
            def = 0;
        }
        if (item == null || item == undefined || item == '' || item == 'undefined') {
            return def;
        }
        if (isNaN(item)) {
            return def;
        }
        return parseInt(item);
    },
    /*
     * Function replace all item
     */
    replaceAllItem: function (item, txtSource, txtTagert) {
        if (item == null || item == undefined || item == '') {
            return '';
        }
        return item.replace('/' + txtSource + '/g', txtTagert);

    },
    /*
     * common: check date item
     */
    _chkDate: function (strDate) {
        if (strDate == null || strDate == "") {
            return true;
        }
        if (strDate.indexOf("/") > 0) {
            return this._isDate(strDate, "/");
        } else {
            return this._isDate(strDate);
        }
    },
    /*
     * common: check _isDate
     */
    _isDate: function (DateString, Dilimeter) {
        if (DateString == null) return false;
        var pattern;
        var year = "";
        var month = "";
        var day = "";
        var temparray = new Array();
        if (Dilimeter == "" || Dilimeter == null) {
            pattern = /^[1-9][0-9]{3}[0-1][0-9][0-3][0-9]$/;

            if (DateString.length != 8) return false;
            year = DateString.substr(0, 4);
            month = DateString.substr(4, 2);
            day = DateString.substr(6, 2);
        } else {
            pattern = /^[1-9][0-9]{3}[\/][0-1]?[0-9][\/][0-3]?[0-9]$/;
            temparray = DateString.split(Dilimeter);
            if (temparray.length != 3) return false;
            if (temparray[0].length == 4) {
                year = temparray[0];
                month = temparray[1];
                day = temparray[2];
            } else {
                year = temparray[2];
                month = temparray[0];
                day = temparray[1];
            }
        }

        if (!pattern.test(DateString)) {
            return false;
        }
        if (isNaN(Date.parse(month + "/" + day + "/" + year))) {
            return false;
        }

        var dd = parseInt(day, 10);
        var mm = parseInt(month, 10) - 1;
        var yy = parseInt(year, 10);
        var date = new Date(yy, mm, dd);
        if (yy < 1901) {
            return false;
        }

        if (dd != date.getDate() || mm != date.getMonth() || yy != date.getFullYear()) {
            return false;
        }
        return true;
    },
    /*
     * common: check null item
     */
    isNullItem: function (item, type) {
        if (item == undefined || item == null || item == '' || item == 'undefined') {
            return true;
        }
        if ("number" == type) {
            if ((item + '') == '0') {
                return true;
            }
        } else if ("string" == type) {
            if (item == '') {
                return true;
            }
        }
        return false;
    },
    /*
     * common: remove storage
     */
    removeLocalStorage() {
        sessionStorage.removeItem('compNm');
        sessionStorage.removeItem('leftMenu');
        sessionStorage.removeItem('accessedScreens');
        sessionStorage.removeItem('template');
        sessionStorage.removeItem('authorization');
        sessionStorage.removeItem('language');
        sessionStorage.removeItem('currentURL');
    },
    /*
     * common: remove storage on EcSite
     */
    removeLocalStorageEcSite(site) {
        localStorage.removeItem('aution-' + site.toLowerCase());
        localStorage.removeItem('language');
        localStorage.removeItem('template');
        sessionStorage.removeItem('COUPON_POPUP_FLG');
        sessionStorage.removeItem('hopeDayList');
        sessionStorage.removeItem('totalPointKin');
        sessionStorage.removeItem('amazonPayInfo');
        sessionStorage.removeItem('amazonCheckoutSessionId');
    },
    /*
     * common: scrollTop
     */
    scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    /*
     * common: check valid class
     */
    checkValidClass(srcElement, classNm) {
        var splitClass = srcElement.split(' ');
        if (splitClass.length > 0) {
            for (var c = 0; c < splitClass.length; c++) {
                if (splitClass[c] == classNm) {
                    return true;
                }
            }
        }
        return false;
    },
    /*
     * common: _checkSkip
     */
    _checkSkip(elm) {
        this.skip = ["button", "submit", "hidden"];
        for (var i in this.skip) {
            if (elm.type == this.skip[i]) return false;
        }
        return true;
    },
    /*
     * common: setFocus
     */
    setFocus() {
        if (this.initFlag) {
            var array = Array.prototype.slice.call(document.querySelectorAll('input, select, textarea'));
            for (var i = 0; i < array.length; i++) {
                var elm = array[i];
                if (!this._checkSkip(elm)) continue;
                if (elm.disabled == true) continue;
                if (elm.readOnly == true) continue;
                if (elm.tabIndex == -1) continue;
                if (elm.style.display == 'none') continue;
                try {
                    elm.focus();
                } catch (e) {
                    continue;
                }
                return;
            }
        }

    },
    /*
     * common: setFocusCC
     */
    setFocusCC() {
        if (this.initFlagCC) {

            var array = Array.prototype.slice.call(document.querySelectorAll('.modal-body input, .modal-body select, .modal-body textarea'));
            for (var i = 0; i < array.length; i++) {
                var elm = array[i];
                if (!this._checkSkip(elm)) continue;
                if (elm.disabled == true) continue;
                if (elm.readOnly == true) continue;
                if (elm.tabIndex == -1) continue;
                if (elm.style.display == 'none') continue;
                try {
                    elm.focus();
                } catch (e) {
                    continue;
                }
                return;
            }
        }

    },
    /*
     * common: setFocusFirstBtn
     */
    setFocusFirstBtn() {
        var array = Array.prototype.slice.call(document.querySelectorAll('button'));
        for (var i = 0; i < array.length; i++) {
            var elm = array[i];
            if (elm.disabled == true) continue;
            if (elm.readOnly == true) continue;
            if (elm.tabIndex == -1) continue;
            if (elm.style.display == 'none') continue;
            try {
                elm.focus();
            } catch (e) {
                continue;
            }
            return;
        }
    },
    /*
     * common: showModalHelp
     */
    showModalHelp: function (programId, colId) {
        var _this = this;
        var data = {};
        data.programId = programId; //'MS021ItemEntry'
        data.colId = colId; //'itemNo'

        var urlRequest = '/master/ms054/getMsg';
        axios.post(urlRequest, data).then(function (response) {
            if (response.data.descriptionItem != undefined) {
                _this.msg = (response.data.descriptionItem.msg ? response.data.descriptionItem.msg : '');
                EventBus.$emit("help-input", _this.msg);
            }

        }).catch(function (error) {
            common.errorAPI(error);
        });
    },
    /*
     * common: displayHelpBtn
     */
    displayHelpBtn: function (screenId, programId) {
        if (this.initFlag) {
            if (common.helpFlg > 0) {
                return;
            }
            // common.helpFlg += 1;
            // get list btn help
            var itemDescriptionList = [];
            var urlRequest = '/master/ms054/getHelpItems';
            var data = {};
            data.programId = programId;
            axios.post(urlRequest, data).then(function (response) {
                if (response.data.colIdList != undefined) {
                    itemDescriptionList = response.data.colIdList;
                    for (var i = 0; i < itemDescriptionList.length; i++) {
                        var colId = itemDescriptionList[i].colId + '_lbl';
                        var element = document.getElementById(colId);
                        if (element != null) {
                            var parentElement = element.parentElement;
                            if (parentElement != null) {
                                var htmlBnt = '<button type="button" id="' + itemDescriptionList[i].colId + '_' + screenId + '" programId="' + programId + '" class="btn btn-secondary btn-sm helpClick">HELP</button>';
                                $(parentElement).append(htmlBnt);
                            }
                        }
                    }

                }

            }).catch(function (error) {
                common.errorAPI(error);
            });


        }
    },
    /*
     * common: formatPrice
     */
    formatPrice(value) {
        if (value != undefined && value != null && value != '') {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return 0;
        }
    },
    /*
     * common: getLengthObj
     */
    getLengthObj(obj) {
        var size = 0,
            key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++;
        }
        return size;
    },
    /*
     * common: setCssPage
     */
    setCssPage(object, data) {
        object.titleNm = data.cssParam1;
        object.siteText = data.cssParam2;
        object.siteTag = data.cssParam3;
        object.pgColor = data.cssParam4;
        object.linkColor = data.cssParam5;
        object.overLinkColor = data.cssParam6;
        object.pgImg = data.cssParam7;
        //get keywords
        var arrSiteTag = object.siteTag ? object.siteTag.split(',') : [];

        for (var i = 0; i < arrSiteTag.length; i++) {
            if (i == 5) {
                break;
            } else if (i == 0) {
                object.keyWords = arrSiteTag[i];
            } else {
                object.keyWords = object.keyWords + ',' + arrSiteTag[i];
            }
        }

        if (data.gaMList != undefined && data.gaMList != null) {
            object.gaMList = data.gaMList;
            //  add google analitics
            var gamItems = '';
            // eslint-disable-next-line
            for (var i = 0; i < object.gaMList.length; i++) {
                gamItems = gamItems + object.gaMList[i].KANRI_DATA;
            }
            if (gamItems != '') {
                $(document).ready(function () {
                    $("head").append(gamItems);
                });
            }
        }
    },
    /*
     * common: setATagStyle
     */
    setATagStyle(linkColor, overLinkColor) {
        var aList = document.querySelectorAll('a');
        var a;
        if (aList.length == 0) return;
        for (var i in aList) {
            a = aList[i];
            if (a.style != undefined) {
                a.style.color = linkColor;
                a.onmouseout = function () {
                    if (this.style != undefined) {
                        this.style.color = linkColor;
                    }
                }

                a.onmouseover = function () {
                    if (this.style != undefined) {
                        this.style.color = overLinkColor;
                    }
                }
            }
        }
    },
    /**
     * Get image default - noimage.gif
     */
    getImgDefault() {
        return imgDefault;
    },
    /**
     * Function getImages
     * @param {String} key 
     * 
     * openNewWindow: open-new-window16x16.png
     * help: help-16x16.png
     */
    getImages(key){
        switch (key) {
            case 'openNewWindow':
                return openNewWindowBtn;
            default:
                break;
        }
        return '';
    },
    /**
     * Function isMobile
     */
    isMobile() {
        if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * Function isChrome
     */
    isChrome: function () {
        if (navigator.userAgent.indexOf("Chrome") >= 0) {
            return true;
        }
        return false;
    },
    /**
     * Function set Favicon
     */
    setFavicon(url) {
        common.removeFavicon();
        var link=document.createElement('link');
        link.type='image/x-icon';
        link.rel='icon';
        link.href=url;
        document.getElementsByTagName('head')[0].appendChild(link);
    },
    /**
     * Function remove Favicon
     */
    removeFavicon() {
        var links=document.getElementsByTagName('link');
        var head=document.getElementsByTagName('head')[0];
        for(var i=0; i<links.length; i++) {
            if(links[i].getAttribute('rel')==='icon'){
                head.removeChild(links[i])
            }
        }
    },
    /* 
        配列型のプロパティのnullの要素にブランクを設定(WAF対応)
        @param obj: 配列型のプロパティを含むObject
    */
    fillArrays: function(obj) {
        if (!obj) {
            return;
        }
        var _this = this;
        for (var key in obj) {
            if (Array.isArray(obj[key])) {
                for (var i = 0; i < obj[key].length; i++) {
                    if (obj[key][i] == null) {
                        obj[key][i] = '';
                    }
                }
            }
            if (typeof obj[key] === 'object') {
                // 再帰的にオブジェクトを探索
                _this.fillArrays(obj[key]);
            }
        }
        // console.log(JSON.stringify(obj));
    },
}

$(document).on("keypress", "input, a, button, select", function (e) {
    common.initFlag = false;
    common.initFlagCC = false;
    if (e.currentTarget.classList.contains('no-enter-as-tab')) return;
    if (e.which == 13 || e.keyCode == 13) {
        e.preventDefault();
        var $canfocus = Array.prototype.slice.call(document.querySelectorAll('input, button, select, textarea'));
        var index = $canfocus.indexOf(document.activeElement) + 1;
        while ($canfocus[index].type == 'radio') {
            index += 1;
        }
        if (index >= $canfocus.length) index = 0;
        $canfocus[index].focus();
    }
});
$(document).on("mousedown", function (e) {
    common.initFlag = false;
    common.initFlagCC = false;
});
$(document).on("keydown", function (e) {
    common.initFlag = false;
    common.initFlagCC = false;
});
$(document).on("change", "input, a, button, select, textarea", function (e) {
    common.initFlagCC = false;
});
$(document).on("click", ".helpClick", function (e) {
    var colId = this.id.split('_')[0];
    var programId = this.attributes.programId.nodeValue;
    common.showModalHelp(programId, colId);

});

(function(window){
    'use strict';
    // These functions will contain all our code below
    function api(){
        var _apiObject = {};
        /* 
        * Function to check logged in or not
        * @callback: this is a callback function
        */
        _apiObject.f_login = function(callback){
            axios.get(UrlConstants.ECSITE + UrlConstants.PT060 + UrlConstants.DO_INIT).then(function(response){
                if (typeof callback == 'function'){
                    callback(response.data)
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        };
        _apiObject.f_logout = function(callback){
            axios.get(UrlConstants.ECSITE + UrlConstants.PT060 + UrlConstants.LOGOUT).then(function(response){
                if (typeof callback == 'function'){
                    callback(response.data)
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
            localStorage.removeItem('aution-' + window.location.href.split("/")[4].toLowerCase());
            localStorage.removeItem('language');
            localStorage.removeItem('template');
        };
        /* 
        * Function to count of product in cart
        * @callback: this is a callback function
        */
        _apiObject.f_count = function(callback){
            axios.get(UrlConstants.ECSITE + UrlConstants.PT010 + UrlConstants.DO_INIT).then(function(response){
                if (typeof callback == 'function'){
                    callback(response.data)
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        };
        /* 
        * Function to get product detail via sItemNo
        * OR to get all products in cart when sItemNo is undefined
        * @sItemNo: s_item_no
        * @callback: this is a callback function
        */
        _apiObject.f_cart = function(callback, sItemNo){
            var reqModel = {};
            if(sItemNo != undefined) {
                reqModel.sItemNo = sItemNo;
                axios.post(UrlConstants.ECSITE + UrlConstants.PT120 + UrlConstants.DO_INIT, reqModel).then(function(response){
                    if (typeof callback == 'function'){
                        callback(response.data)
                    }
                }).catch(function(error) {
                    common.errorAPI(error);
                });
            } else {
                axios.post(UrlConstants.ECSITE + UrlConstants.PT180 + UrlConstants.DO_INIT, reqModel).then(function(response){
                    if (typeof callback == 'function'){
                        callback(response.data)
                    }
                }).catch(function(error) {
                    common.errorAPI(error);
                });
            }
        };
        /* 
        * Function to get rank of customer
        * @callback: this is a callback function
        */
        _apiObject.f_cust = function(callback){
            axios.get(UrlConstants.ECSITE + UrlConstants.PT400 + UrlConstants.DO_INIT).then(function(response){
                if (typeof callback == 'function'){
                    callback(response.data)
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        };
        /* 
        * Function to get rank of customer
        * @callback: this is a callback function
        */
        _apiObject.f_point = function(callback){
            var reqModel = {};
            axios.post(UrlConstants.ECSITE + UrlConstants.PT480 + UrlConstants.DO_INIT, reqModel).then(function(response){
                if (typeof callback == 'function'){
                    callback(response.data)
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        };

        /* 
        * Function to get 出荷予定日
        * @callback: this is a callback function
        */
        _apiObject.f_syukkaYoteiYmd = function(callback){
            var reqModel = {};
            axios.post(UrlConstants.ECSITE + UrlConstants.PT120 + UrlConstants.GET_SYUKKA_YOTEI_YMD, reqModel).then(function(response){
                if (typeof callback == 'function'){
                    callback(response.data)
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        };
        
        return _apiObject;
    }
  
    // We need that our library is globally accesible, then we save in the window
    if(typeof(window.api) === 'undefined'){
      window.api = api();
    }
})(window);

export default common